import React, {FormEvent} from 'react';
import {Button} from 'antd';
import './style.css';

/**
 * A reusable button component using Ant Design's Button.
 *
 * @param {Object} props - The properties passed to the button component.
 * @param {(event: FormEvent) => Promise<void>} props.onClick - A function to handle the click event. It should return a promise.
 * @param {string} props.label - The label to be displayed on the button.
 * @param {'link' | 'text' | 'default' | 'primary' | 'dashed' | undefined} [props.buttonType] - The type of button style as per Ant Design. Defaults to 'default'.
 * @param {string} [props.className] - Additional custom class names to style the button.
 *
 * @returns {React.ReactElement} A styled button component.
 */
type ButtonProps = {
    onClick: (event: FormEvent) => Promise<void>;
    label: string;
    buttonType?: 'link' | 'text' | 'default' | 'primary' | 'dashed' | undefined;
    className?: string;
    disabled?: boolean;
};

const ButtonComponent = ({onClick, label, buttonType, className, disabled}: ButtonProps) => {
    return (<Button type={buttonType} onClick={onClick} className={className} disabled={disabled}>{label}</Button>);
};

export default ButtonComponent;